import { Button, Grid, makeStyles, TextField } from '@material-ui/core';
import React, { FC, useState, useEffect } from 'react';
import Card from '../components/card.component';
import { getDeck, shuffle } from '../shared/deck';
import { cloneDeep } from 'lodash';
import Pyramid from '../components/pyramid.component';
import clsx from 'clsx';
import compareCards from '../shared/compareCards';
import Bus from '../components/bus.component';

const useStyles = makeStyles(theme => ({
  root: {
  },
  marginFix: {
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2)
  },
  active: {
    backgroundColor: '#999'
  },
  tac: {
    textAlign: 'center'
  },
  cardColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));

interface Player {
  name: string;
  cards: string[];
}

enum State {
  CREATING,
  SHARING,
  PYRAMID,
  BUS
}

const HostPage: FC = (props) => {

  const classes = useStyles(props);

  const [state, setState] = useState({
    deck: [] as string[],
    players: [] as Player[],
    active: -1,
    state: State.CREATING,
    pyramidCards: [] as string[],
    currentPyramid: 'a9001'
  });

  const [canBus, setCanBus] = useState(false);

  const [name, setName] = useState('');

  useEffect(() => {

    function handleKey(ev: KeyboardEvent) {
      if (ev.code === 'KeyD') {
        console.log(state.deck);
      }
    }

    window.addEventListener('keyup', handleKey);
    return () => {
      window.removeEventListener('keyup', handleKey)
    }
  }, [state]);

  function addPlayer() {

    const copy = state.players.slice();
    copy.push({
      name: name,
      cards: []
    })

    setState({ ...state, players: copy });
    setName('');
  }

  function start() {
    // Determine the amount of cards needed

    const numDecks = Math.ceil(state.players.length / 9);

    let cards: string[] = [];
    for (let i = 0; i !== numDecks; ++i) {
      cards.push(...getDeck());
    }
    cards = shuffle(cards);
    setName('');
    setState({ ...state, state: State.SHARING, deck: cards, active: 0 });
  }

  const handleCardClick = (player: string, card: string) => () => {

    const mayRemove = compareCards(state.currentPyramid, card) === 0;

    if (mayRemove) {
      const copy = cloneDeep(state);
      copy.players.forEach(p => {
        if (p.name === player) {
          p.cards = p.cards.filter(c => c !== card);
        }
      });
      setState(copy);
    } else {
      alert('Adtje des!');
    }
  }

  function enableBus(bus: boolean) {
    setCanBus(bus);
  }

  /**
   * Give a card to the current player
   */
  function giveCard() {
    const newState = cloneDeep(state);
    const card = newState.deck.pop()!;
    newState.players[newState.active].cards.push(card);
    newState.active = (newState.active + 1) % newState.players.length;
    // Check if everyone has cards
    const needCards = newState.players.find(p => p.cards.length !== 4);
    newState.state = needCards ? State.SHARING : State.PYRAMID;

    if (newState.state === State.PYRAMID) {
      newState.pyramidCards = newState.deck.slice(0, 16);
      newState.active = -1;
    }

    setState(newState)
  }

  /**
   * Set which card the players may throw on the pyramid
   * @param card
   */
  function handlePyramidOpen(card: string) {
    setState({ ...state, currentPyramid: card });
  }

  function gotoBus() {
    setState({ ...state, state: State.BUS });
  }

  function resetGame() {
    setCanBus(false);
    setState({
      deck: [] as string[],
      players: [] as Player[],
      active: -1,
      state: State.CREATING,
      pyramidCards: [] as string[],
      currentPyramid: 'a9001'
    })
  }

  return (
    <Grid container direction="column"
      className={classes.root}
    >
      <Grid item className={classes.tac}>
        <h3>Bussen met het Luchtschip</h3>
      </Grid>

      {
        state.state === State.BUS ? (
          <Bus
            resetGame={resetGame}
          />
        ) : (
            <Grid item container direction="row" justify="center">

              {
                state.players.map((p, idx) => {
                  return (
                    <Grid item key={p.name} xs={1}
                      className={clsx(idx === state.active && classes.active)}>
                      <h3 className={classes.tac}>
                        {p.name}
                      </h3>
                      {
                        p.cards.map((c, idx) => (
                          <div key={idx} className={classes.cardColumn}>
                            <Card
                              card={c}
                              open={true}
                              onClick={handleCardClick(p.name, c)}
                            />
                          </div>
                        ))
                      }
                    </Grid>
                  )
                })
              }
              {
                state.state === State.CREATING &&
                (
                  <Grid item xs={2}>
                    <div>
                      <TextField
                        label="Naam"
                        value={name}
                        fullWidth
                        onChange={evt => setName(evt.currentTarget.value)}
                      />
                    </div>
                    <Button
                      onClick={addPlayer}
                      color="primary"
                      fullWidth
                    >
                      <span>voeg toe</span>
                    </Button>

                    <Button
                      onClick={start}
                      color="primary"
                      fullWidth
                    >
                      <span>start spel</span>
                    </Button>
                  </Grid>
                )
              }

              {
                state.state === State.SHARING &&
                (
                  <Grid item className={classes.cardColumn}>
                    <div>
                      <span>{state.deck.length} kaarten</span>
                    </div>

                    <div>
                      <Card card="hA" open={false} />
                    </div>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={giveCard}
                    >
                      <span>deel kaart</span>
                    </Button>
                  </Grid>
                )
              }
              {
                canBus &&
                (
                  <Grid item className={classes.cardColumn}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={gotoBus}
                    >
                      <span>... in de bus!</span>
                    </Button>
                  </Grid>
                )
              }

            </Grid>
          )
      }




      {
        state.state === State.PYRAMID &&
        (
          <Grid item>
            <Pyramid
              players={state.players.map(p => p.name)}
              cards={state.pyramidCards}
              handlePyramidOpen={handlePyramidOpen}
              enableBus={enableBus}
            />
          </Grid>
        )
      }
    </Grid>
  )
}

export default HostPage;
